<template>
    <div class="card-body bg-white">
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="name"
                   :class="{'text-red': newCompanyForm.errors.has('name')}">Name</label>
            <input v-model="newCompanyForm.name" id="name" name="name" maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('name')}">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('name')">{{ newCompanyForm.errors.get('name') }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="searchTextFieldCompany"
                   :class="{'text-red': newCompanyForm.errors.has('address')}">Address</label>
            <input v-model="newCompanyForm.address" id="searchTextFieldCompany" name="address" maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('address')}" @focusin="initAutocompleteCompany">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('address')">{{
                    newCompanyForm.errors.get('address') }}
            </div>
            <input v-model="newCompanyForm.lat" type="hidden" name="lat"
                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
            <input v-model="newCompanyForm.lng" type="hidden" name="lng"
                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="city"
                   :class="{'text-red': newCompanyForm.errors.has('city')}">City</label>
            <input v-model="newCompanyForm.city" type="text" name="city" id="city" maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('city')}">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('city')">{{ newCompanyForm.errors.get('city') }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="state"
                   :class="{'text-red': newCompanyForm.errors.has('state')}">State</label>
            <input v-model="newCompanyForm.state" type="text" id="state" title="state" maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('state')}">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('state')">{{ newCompanyForm.errors.get('state')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="zip"
                   :class="{'text-red': newCompanyForm.errors.has('zip')}">Zip</label>
            <input v-model="newCompanyForm.zip" type="text" id="zip" name="zip" maxlength="64"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('zip')}">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('zip')">{{ newCompanyForm.errors.get('zip') }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="phone"
                   :class="{'text-red': newCompanyForm.errors.has('phone')}">Phone</label>

            <div class="input-group mb-3">
                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        {{symbols.DDI}}
                                    </span>
                </div>
                <input v-model="newCompanyForm.phone" id="phone" title="phone" maxlength="64"
                       v-mask="masks.v_mask_phone"
                       class="form-control bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                       :class="{'border-red': newCompanyForm.errors.has('phone')}">
            </div>
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('phone')">{{ newCompanyForm.errors.get('phone')
                }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm" for="fax"
                   :class="{'text-red': newCompanyForm.errors.has('fax')}">Fax</label>
            <input v-model="newCompanyForm.fax" id="fax" name="fax" maxlength="64"
                   v-mask="masks.v_mask_phone"
                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                   :class="{'border-red': newCompanyForm.errors.has('fax')}">
            <div class="text-red text-sm" v-if="newCompanyForm.errors.has('fax')">{{ newCompanyForm.errors.get('fax') }}
            </div>
        </div>
        <div class="mb-2">
            <label class="text-grey-darkest text-sm"
                   :class="{'text-red': newCompanyForm.errors.has('company_types_id')}">Company Type</label>
            <div class="flex-col ">
                <multiselect
                    class="cursor-pointer"
                    :options="companyTypes"
                    v-model="selectedCompanyType"
                    :show-labels="false"
                    @input="newCompanyForm.errors.clear('company_types_id')"
                    track-by="id"
                    label="code"
                    value="id">
                </multiselect>
                <div class="text-red text-sm" v-if="newCompanyForm.errors.has('company_types_id')">The company type field is required.</div>
            </div>
        </div>
        <div class="mb-2">
            <company-custom-fields ref="CompanyCustomFields" base="create" :customFieldErrors="newCompanyForm.errors" :isGenericFormRequest="true"></company-custom-fields>
        </div>
        <div class="mb-2" style="text-align: right;">
            <button type="button" @click="submit()" class="btn btn-primary" :disabled="createProcessing">
                <i v-if="createProcessing" class="fa fa-spin fa-spinner" aria-hidden="true"></i>&nbsp;
                Create & Add
            </button>
        </div>
    </div>
</template>

<script>
import ContactCustomFields from "../contact/custom-fields/contact-custom-fields.vue";
import Multiselect from "vue-multiselect";
import Form from "../../utils/form";
import axios from "axios";
let autocomplete=null;

export default {
    name: 'company-create-form',
    components: {Multiselect, ContactCustomFields},
    props: ['masks', 'symbols', 'contact', 'forAssociationCompany'],
    data() {
        return {
            newCompanyForm: new Form({
                name: null,
                address: null,
                city: null,
                state: null,
                zip: null,
                lat: null,
                lng: null,
                phone: null,
                fax: null,
                company_types_id: null,
                customFieldsData: null,
                contactId: this.contact ? this.contact.id : null,
                isAssociationCompany: this.forAssociationCompany ?? false,
            }),
            companyTypes: [],
            selectedCompanyType: null,
            createProcessing: false
        }
    },
    watch: {
        selectedCompanyType: function(val, oldVal) {
            this.newCompanyForm.company_types_id = val ? val.id : null;
        }
    },
    mounted() {
        this.getCompanyTypes();
    },
    methods: {
        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id:null,code:""})
            });
        },
        submit() {
            let self = this;
            self.createProcessing = true;
            self.newCompanyForm.customFieldsData = self.$refs.CompanyCustomFields.form;

            this.newCompanyForm.post(route('api.company.add.new-company')).then((response) => {
                self.createProcessing = false;
                self.resetCreateForm();
                self.$refs.CompanyCustomFields.form = null;
                self.$refs.CompanyCustomFields.fetchCustomFields();
                self.getToast().fire({
                    type: 'success',
                    title: 'Company created successfully'
                });
                self.$emit('companyCreated');
            }).catch((error) => {
                self.createProcessing = false;
            });
        },
        resetCreateForm() {
            this.newCompanyForm.name = null;
            this.newCompanyForm.address = null;
            this.newCompanyForm.city = null;
            this.newCompanyForm.state = null;
            this.newCompanyForm.zip = null;
            this.newCompanyForm.lat = null;
            this.newCompanyForm.lng = null;
            this.newCompanyForm.phone = null;
            this.newCompanyForm.fax = null;
            this.newCompanyForm.company_types_id = null;
            this.newCompanyForm.customFieldsData = null;
            this.newCompanyForm.errors.errors = {};
            this.selectedCompanyType = null;
        },
        initAutocompleteCompany() {
            let input = document.getElementById('searchTextFieldCompany');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });
            console.log(autocomplete);
            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponentsCompany);
        },
        getAddressComponentsCompany() {
            let placeResultData = autocomplete.getPlace();
            this.newCompanyForm.lat = placeResultData.geometry.location.lat();
            this.newCompanyForm.lng = placeResultData.geometry.location.lng();
            this.newCompanyForm.zip = '';
            this.newCompanyForm.city = '';
            this.newCompanyForm.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.newCompanyForm.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.newCompanyForm.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.newCompanyForm.state = res.short_name;
                }
            });
            this.newCompanyForm.address = placeResultData.name;
        },
    }
}
</script>

<style scoped>

</style>
